<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div id="header-container">
  <h1 id="header-text">{{ titleText }}</h1>
  <div id="actions-container">
    <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()" *ngIf="!isEmpty(data)">
      Cancel
    </button>
    <button mat-raised-button color="primary" id="confirm-button" class="action-button"
            (click)="onConfirm()" [disabled]="selectedMemberScenarios?.length === 0">
      {{ confirmText }}
    </button>
  </div>
</div>
<div class="set-height">
  <app-global-scenario-select-component
    [user]="user"
    [memberScenarioType]="memberScenarioType"
    [displayedMemberColumns]="displayedMemberHeaders"
    [filterNonGM]="filterNonGM"
    (confirmEvent)="onSelectEvent($event)"></app-global-scenario-select-component>
</div>
